var React = require('react');

function IconNon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#142B6F","d":"M33.488,6.342c-0.014-0.014-0.018-0.033-0.031-0.047c-0.021-0.021-0.051-0.029-0.074-0.049\tC29.92,2.876,25.201,0.791,20,0.791C9.408,0.791,0.791,9.408,0.791,20c0,10.592,8.617,19.209,19.209,19.209\tc10.592,0,19.209-8.617,19.209-19.209C39.209,14.661,37.016,9.827,33.488,6.342z M20,3.791c3.868,0,7.418,1.365,10.208,3.633\tL7.424,30.207C5.156,27.418,3.791,23.867,3.791,20C3.791,11.061,11.062,3.791,20,3.791z M20,36.209\tc-3.992,0-7.646-1.457-10.473-3.859L32.35,9.526c2.402,2.828,3.859,6.481,3.859,10.474C36.209,28.938,28.938,36.209,20,36.209z"}));
}

IconNon.defaultProps = {"width":"50","height":"50","x":"0","y":"0","enableBackground":"new -5 -5 50 50","version":"1.1","viewBox":"-5 -5 50 50","xmlSpace":"preserve"};

module.exports = IconNon;

IconNon.default = IconNon;
